// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name='RadioGroup'] .name {\n    color: #b5b5b5;\n    font-family: Montserrat;\n    font-size: 12px;\n    font-weight: 600;\n    letter-spacing: 1px;\n    margin-bottom: 10px;\n    display: block;\n  }\n", ""]);
// Exports
module.exports = exports;
